import React from 'react';
import { useTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import SubscriptionCenter from './SubscriptionCenter';

const SubscriptionCenterBox: React.FC<WidgetBoxProps> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  isCurrentUserProfileOwner,
  profileOwnerUser,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t(`widgets.subscription_center.header`)}
      hasMore={false}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={false}
    >
      <SubscriptionCenter moduleId={moduleId} {...props} />
    </WidgetBox>
  );
};

SubscriptionCenterBox.displayName = 'SubscriptionCenterBox';
export default SubscriptionCenterBox;
